import { render, staticRenderFns } from "./ChangeInvoiceDueDateDialog.vue?vue&type=template&id=f772fe8a&"
import script from "./ChangeInvoiceDueDateDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeInvoiceDueDateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports